import { ChangeDetectionStrategy, Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { DefaultMira, SubItem, SubItemFavorite } from '@irohalab/mira-sdk-angular';
import { DatePipe, NgClass } from '@angular/common';
import { Subscription } from 'rxjs';

export type Episode = { labelClass: string, publicTime: Date | null, expand: boolean } & Omit<SubItem, 'publicTime'>

@Component({
    selector: 'app-episode-list',
    imports: [
    NgClass,
    DatePipe
],
    templateUrl: './episode-list.component.html',
    styleUrl: './episode-list.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpisodeListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private miraApiService = inject(DefaultMira);

  subItems = input.required<SubItem[]>();
  itemId = input.required<string>();

  toggleMap: { [key: string]: boolean } = {};

  subItemFavorites: SubItemFavorite[] = [];

  epList: Episode[] = [];
  spList: Episode[] = [];

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    const subItems = this.subItems();
    for (const subItem of subItems) {
      this.toggleMap[subItem.id] = false;
    }
    this.buildLists();
    this.subscription.add(
      this.miraApiService.listSubItemFavorites(this.itemId())
        .subscribe({
          next: ({data}) => {
            this.subItemFavorites = data;
            this.buildLists();
          },
          error: (err) => {
            console.log(err);
          }
        })
    );
  }

  private buildLists(): void {
    const subItems = this.subItems();
    this.epList = subItems
      ? subItems
          .filter(subItem => subItem.episodeType === SubItem.EpisodeTypeEnum.Episode)
          .map(subItem => this.mapSubItemToEpisode(subItem))
      : [];
    this.spList = subItems
      ? subItems
          .filter(subItem => subItem.episodeType === SubItem.EpisodeTypeEnum.Special)
          .map(subItem => this.mapSubItemToEpisode(subItem))
      : [];
  }

  toggleEps(episode: Episode): void {
    if (!episode.desc) {
      return;
    }
    this.toggleMap[episode.id] = !this.toggleMap[episode.id];
  }

  private mapSubItemToEpisode(subItem: SubItem): Episode {
    const ep: Episode = Object.assign({}, subItem) as unknown as Episode;
    ep.mainItem = undefined;
    ep.publicTime = subItem.publicTime ? new Date(subItem.publicTime) : null;
    ep.labelClass = this.getLabelClass(ep);
    return ep;
  }

  private getLabelClass(subItem: Episode): string {
    const fav = this.subItemFavorites ? this.subItemFavorites.find(sf => sf.subItem?.id === subItem.id) : null;
    const currentDate = new Date();
    if (fav) {
      return 'olive';
    } else {
      if (!subItem.publicTime || (subItem.publicTime && this.dateLevelCompare(subItem.publicTime, currentDate) > 0)) {
        return 'secondary';
      } else if (subItem.publicTime && this.dateLevelCompare(subItem.publicTime, currentDate) === 0) {
        return 'teal';
      } else {
        return '';
      }
    }
  }

  private dateLevelCompare(d1: Date, d2: Date): number {
    const yearDiff = d1.getFullYear() - d2.getFullYear();
    if (yearDiff === 0) {
      const monthDiff = d1.getMonth() - d2.getMonth();
      if (monthDiff === 0) {
        return d1.getDate() - d2.getDate();
      } else {
        return monthDiff;
      }
    } else {
      return yearDiff;
    }
  }
}
